import { useContext } from 'react';

import HistoryOfChangesContext from './context';

export default function useHistoryOfChanges() {
    return useContext(HistoryOfChangesContext);
}
